import React from 'react';
import { graphql } from 'gatsby';
import { Layout } from 'components/layout';
import SEO from 'components/Seo';
import ClientLogos from 'components/ClientLogos';
import { Hero, About, Services, RecentWork } from '../sections';
import Section from '../components/Section';

const IndexPage = ({ data }) => {
  const { hero, aboutUs, services, recentWork } = data.content.childMarkdownRemark.frontmatter;

  return (
    <Layout>
      <SEO title="MARKEDWAY - Creative Digital Studio" />
      <Hero data={hero} />
      <Section paddingTop36>
        <ClientLogos />
      </Section>
      <About data={aboutUs} />
      <Services data={services} />
      <RecentWork data={recentWork} />
      {/* <News */}
      {/*  cards={cards} */}
      {/*  title={news.sectionTitle.title} */}
      {/*  subTitle={news.sectionTitle.subTitle} */}
      {/*  button={news.sectionTitle.button} */}
      {/* /> */}
    </Layout>
  );
};

export default IndexPage;

export const PageQuery = graphql`
  query {
    content: file(name: { eq: "homepage" }) {
      childMarkdownRemark {
        frontmatter {
          hero {
            sectionTitle {
              subTitle
              title
              body
              button {
                text
                url
              }
            }
            imageContainer {
              altText
              image {
                publicURL
              }
            }
          }
          aboutUs {
            sectionTitle {
              subTitle
              title
              body
              button {
                text
                url
              }
            }
            numbers {
              number
              text
            }
            cardsHeading
            cards {
              title
              description
              imageContainer {
                image {
                  publicURL
                }
                altText
              }
            }
          }
          services {
            sectionTitle {
              subTitle
              title
              button {
                text
                url
              }
            }
            cards {
              title
              description
              imageContainer {
                image {
                  publicURL
                }
                altText
              }
            }
            audit {
              auditTitle
              description
              button {
                text
                url
              }
            }
          }
          recentWork {
            sectionTitle {
              subTitle
              title
              button {
                text
                url
              }
            }
            cards {
              title
              description
              projectUrl
              imageContainer {
                image {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                altText
              }
            }
          }
          news {
            sectionTitle {
              subTitle
              title
              button {
                text
                url
              }
            }
          }
        }
      }
    }
    featuredBlogPosts: allMarkdownRemark(
      filter: { frontmatter: { published: { eq: true }, featuredPost: { eq: true } } }
      limit: 3
      sort: { fields: frontmatter___date, order: DESC }
    ) {
      edges {
        node {
          card: frontmatter {
            tag
            date(formatString: "MMMM DD, YYYY")
            title
            description
            path
            imageContainer {
              altText
              image {
                childImageSharp {
                  fluid(maxWidth: 400) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
